import type React from 'react';

import { XIcon } from 'lucide-react';

import { Button } from '#src/app/shared/components/adminShadcn';

export const ImagePreview: React.FC<{ image: string; removeImage: () => void }> = ({ image, removeImage }) => {
	return (
		<div className="admin:relative admin:mb-4 admin:flex admin:overflow-hidden admin:rounded-md admin:border admin:bg-muted">
			<img
				src={image}
				alt=""
				className="admin:aspect-video admin:w-full admin:object-contain"
				data-testid="image-preview"
			/>
			<Button
				variant="outline"
				size="icon-sm"
				data-testid="remove-img-btn"
				className="admin:absolute admin:top-4 admin:right-4"
				onClick={removeImage}
				type="button"
				aria-label="Remove Image"
			>
				<XIcon />
			</Button>
		</div>
	);
};
